import React from 'react';
import { Card, CardBody } from 'reactstrap';

/**
 * Mapeo y estandarización limpia de nombres y límites oficiales para la tabla de coberturas.
 */
var mapearCoberturaOficial = function(item) {
    var codigo = item.cobCodigoCore || 0;
    var rawDesc = (item.cobDescripcion || item.descripcion || item.cobNombre || '').toUpperCase();
    var maxLim = parseFloat(item.cobLimiteMaximo) || 0;

    var formatearMonto = function(monto) {
        return '$' + monto.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    if (codigo === 1 || rawDesc.indexOf('RESPONSABILIDAD') !== -1 || rawDesc.indexOf('RCLUC') !== -1) {
        return {
            id: 'rcluc',
            nombre: 'Responsabilidad Civil (LUC)',
            limite: maxLim > 0 ? formatearMonto(maxLim) : 'Hasta $100,000.00'
        };
    }

    if (codigo === 4 || (rawDesc.indexOf('PERDIDA TOTAL') !== -1 && rawDesc.indexOf('DA') !== -1) || rawDesc.indexOf('PTD') !== -1) {
        return {
            id: 'ptd',
            nombre: 'Pérdida Total del Vehículo por Daños',
            limite: '100% Valor Asegurado'
        };
    }

    if (codigo === 5 || (rawDesc.indexOf('PERDIDA PARCIAL') !== -1 && rawDesc.indexOf('DA') !== -1) || rawDesc.indexOf('PPD') !== -1) {
        return {
            id: 'ppd',
            nombre: 'Pérdida Parcial del Vehículo por Daños',
            limite: 'Según Deducible'
        };
    }

    if (codigo === 6 || (rawDesc.indexOf('PERDIDA TOTAL') !== -1 && rawDesc.indexOf('ROBO') !== -1) || rawDesc.indexOf('PTR') !== -1) {
        return {
            id: 'ptr',
            nombre: 'Pérdida Total del Vehículo por Robo',
            limite: '100% Valor Asegurado'
        };
    }

    if (codigo === 7 || (rawDesc.indexOf('PERDIDA PARCIAL') !== -1 && rawDesc.indexOf('ROBO') !== -1) || rawDesc.indexOf('PPR') !== -1) {
        return {
            id: 'ppr',
            nombre: 'Pérdida Parcial del Vehículo por Robo',
            limite: 'Según Deducible'
        };
    }

    if (codigo === 8 || rawDesc.indexOf('MEDIC') !== -1 || rawDesc.indexOf('GM') !== -1) {
        return {
            id: 'gm',
            nombre: 'Gastos Médicos por Accidente',
            limite: maxLim > 0 ? formatearMonto(maxLim) : '$6,000.00'
        };
    }

    if (codigo === 9 || rawDesc.indexOf('ACCIDENTES PERSONALES') !== -1 || rawDesc === 'AP') {
        return {
            id: 'ap',
            nombre: 'Muerte Accidental o Incapacidad Total y Permanente',
            limite: maxLim > 0 ? formatearMonto(maxLim) : '$10,000.00'
        };
    }

    if (codigo === 10 || rawDesc.indexOf('GRUA') !== -1 || rawDesc.indexOf('GG') !== -1) {
        return {
            id: 'gg',
            nombre: 'Gastos de Grúa, Transporte y Custodia',
            limite: maxLim > 0 ? formatearMonto(maxLim) : '$400.00'
        };
    }

    if (codigo === 11 || rawDesc.indexOf('TRANSPORTE') !== -1 || rawDesc.indexOf('GTR') !== -1) {
        return {
            id: 'gtr',
            nombre: 'Gastos de Transporte para el Asegurado',
            limite: maxLim > 0 ? formatearMonto(maxLim) : '$600.00'
        };
    }

    if (codigo === 12 || rawDesc.indexOf('AMPARO') !== -1 || rawDesc.indexOf('APAT') !== -1) {
        return {
            id: 'apat',
            nombre: 'Amparo Patrimonial',
            limite: maxLim > 0 ? formatearMonto(maxLim) : 'Hasta $50,000.00'
        };
    }

    if (codigo === 14 || rawDesc.indexOf('JURIDIC') !== -1 || rawDesc.indexOf('AJU') !== -1) {
        return {
            id: 'aju',
            nombre: 'Amparo Jurídico en Proceso Penal',
            limite: maxLim > 0 ? formatearMonto(maxLim) : '$1,000.00'
        };
    }

    if (codigo === 16 || rawDesc.indexOf('TERREMOTO') !== -1 || rawDesc.indexOf('TER') !== -1) {
        return {
            id: 'ter',
            nombre: 'Terremoto, Temblor y Erupción Volcánica',
            limite: '100% Valor Asegurado'
        };
    }

    if (codigo === 17 || rawDesc.indexOf('METROASSIST') !== -1 || rawDesc.indexOf('METROASSIT') !== -1 || rawDesc.indexOf('ASIS') !== -1) {
        return {
            id: 'asis',
            nombre: 'Asistencia Vial 24/7 (MetroAssist)',
            limite: 'Servicio Incluido'
        };
    }

    if (codigo === 19 || rawDesc.indexOf('MENORES') !== -1 || rawDesc.indexOf('MEN25') !== -1) {
        return {
            id: 'men25',
            nombre: 'Cobertura para Menores de 25 Años',
            limite: 'Amparado en Póliza'
        };
    }

    if (codigo === 21 || rawDesc.indexOf('ACCESORIOS') !== -1 || rawDesc.indexOf('RPAR') !== -1) {
        return {
            id: 'rpar',
            nombre: 'Robo Parcial de Accesorios Extras',
            limite: maxLim > 0 ? formatearMonto(maxLim) : 'Hasta $2,000.00'
        };
    }

    if (codigo === 26 || rawDesc.indexOf('FUNERARIO') !== -1) {
        return {
            id: 'fun',
            nombre: 'Gastos Funerarios',
            limite: maxLim > 0 ? formatearMonto(maxLim) : '$2,000.00'
        };
    }

    if (codigo === 31 || rawDesc.indexOf('LLAVE') !== -1) {
        return {
            id: 'llave',
            nombre: 'Reposición de Llave Protegida',
            limite: maxLim > 0 ? formatearMonto(maxLim) : 'Hasta $300.00'
        };
    }

    if (codigo === 32 || rawDesc.indexOf('DOCUMENTO') !== -1) {
        return {
            id: 'doc',
            nombre: 'Reposición de Documentos Protegidos',
            limite: maxLim > 0 ? formatearMonto(maxLim) : 'Hasta $300.00'
        };
    }

    var palabras = rawDesc.toLowerCase().split(' ');
    var tituloFormateado = palabras.map(function(p) {
        return p.charAt(0).toUpperCase() + p.slice(1);
    }).join(' ');

    return {
        id: 'cob-' + (codigo || rawDesc),
        nombre: tituloFormateado || 'Cobertura Incluida',
        limite: maxLim > 0 ? formatearMonto(maxLim) : 'Incluido'
    };
};

/**
 * Componente oficial de Coberturas: Tabla sobria corporativa AIG sin botones interrogación ni tooltips.
 */
const CoberturasMoto = ({ coberturas, planNombre }) => {
    var listaRaw = Array.isArray(coberturas) ? coberturas : [];

    var esCoberturasPdf = listaRaw.length > 0 && listaRaw[0] && (listaRaw[0].cobLimite !== undefined || listaRaw[0].limite !== undefined);

    var listaCoberturas = [];
    if (esCoberturasPdf) {
        listaCoberturas = listaRaw.map(function(item, idx) {
            var n = item.cobNombre || item.nombre || '';
            var l = item.cobLimite !== undefined ? item.cobLimite : item.limite;
            var lStr = '';
            if (typeof l === 'number' || (typeof l === 'string' && l.trim() !== '' && !isNaN(l) && isFinite(l))) {
                var nL = parseFloat(l);
                lStr = '$' + nL.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            } else {
                lStr = String(l || 'Amparado');
            }
            return {
                id: 'cob-pdf-' + idx,
                nombre: n,
                limite: lStr
            };
        });
    } else {
        // Deduplicar coberturas preservando el límite superior (Fallback)
        var mapaUnicas = {};
        for (var i = 0; i < listaRaw.length; i++) {
            var raw = listaRaw[i];
            var cobFormateada = mapearCoberturaOficial(raw);
            if (!mapaUnicas[cobFormateada.id]) {
                mapaUnicas[cobFormateada.id] = cobFormateada;
            } else {
                var limActual = parseFloat(mapaUnicas[cobFormateada.id].limite.replace(/[^0-9.-]+/g, '')) || 0;
                var limNuevo = parseFloat(cobFormateada.limite.replace(/[^0-9.-]+/g, '')) || 0;
                if (limNuevo > limActual) {
                    mapaUnicas[cobFormateada.id].limite = cobFormateada.limite;
                }
            }
        }

        listaCoberturas = Object.keys(mapaUnicas).map(function(k) {
            return mapaUnicas[k];
        });
    }

    var planTitulo = (planNombre || 'AIG MOTO').toUpperCase();

    return (
        <Card className="shadow-sm mb-4" style={{ borderRadius: '4px', border: '1px solid #e0e0e0', backgroundColor: '#ffffff' }}>
            <CardBody style={{ padding: '20px 24px' }}>
                <h4 style={{
                    fontSize: '20px',
                    fontWeight: 'bold',
                    color: '#000000',
                    marginBottom: '16px',
                    fontFamily: 'Futura, "Trebuchet MS", Arial, sans-serif'
                }}>
                    Coberturas
                </h4>

                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    overflowX: 'auto',
                    border: '1px solid #d0d7de',
                    borderRadius: '4px'
                }}>
                    {/* Columna Izquierda: Nombres de Coberturas */}
                    <div style={{
                        flex: '1 1 65%',
                        minWidth: '280px',
                        backgroundColor: '#ffffff',
                        borderRight: '1px solid #d0d7de'
                    }}>
                        {/* Encabezado Azul */}
                        <div style={{
                            height: '52px',
                            backgroundColor: '#4ea3de',
                            display: 'flex',
                            alignItems: 'center',
                            padding: '0 24px'
                        }}>
                            <span style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                                color: '#ffffff',
                                fontFamily: 'Futura, "Trebuchet MS", Arial, sans-serif',
                                letterSpacing: '0.3px'
                            }}>
                                Coberturas
                            </span>
                        </div>

                        {/* Filas de Coberturas */}
                        {listaCoberturas.map(function(cob, index) {
                            var esFilaPar = index % 2 === 0;

                            return (
                                <div 
                                    key={'row-cob-' + index}
                                    style={{
                                        height: '56px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '0 24px',
                                        backgroundColor: esFilaPar ? '#fcfcfc' : '#ffffff',
                                        borderBottom: index === listaCoberturas.length - 1 ? 'none' : '1px solid #eeeeee'
                                    }}
                                >
                                    <span style={{
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: '#1a1a1a',
                                        fontFamily: 'Futura, "Trebuchet MS", Arial, sans-serif',
                                        lineHeight: 1.3
                                    }}>
                                        {cob.nombre}
                                    </span>
                                </div>
                            );
                        })}
                    </div>

                    {/* Columna Derecha: Plan Seleccionado */}
                    <div style={{
                        flex: '0 0 35%',
                        minWidth: '200px',
                        backgroundColor: '#ffffff',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        {/* Encabezado del Plan */}
                        <div style={{
                            height: '52px',
                            backgroundColor: '#4ea3de',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0 12px',
                            borderLeft: '1px solid rgba(255,255,255,0.3)'
                        }}>
                            <span style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#ffffff',
                                fontFamily: 'Futura, "Trebuchet MS", Arial, sans-serif',
                                textAlign: 'center',
                                letterSpacing: '0.3px'
                            }}>
                                {planTitulo}
                            </span>
                        </div>

                        {/* Checkmarks y Límites por Fila */}
                        {listaCoberturas.map(function(cob, index) {
                            var esFilaPar = index % 2 === 0;

                            return (
                                <div 
                                    key={'check-cob-' + index}
                                    style={{
                                        height: '56px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: esFilaPar ? '#fcfcfc' : '#ffffff',
                                        borderBottom: index === listaCoberturas.length - 1 ? 'none' : '1px solid #eeeeee',
                                        padding: '0 12px'
                                    }}
                                >
                                    <div style={{
                                        width: '24px',
                                        height: '24px',
                                        borderRadius: '3px',
                                        backgroundColor: '#4192d8',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <i className="fa fa-check" style={{ fontSize: '12px', color: '#ffffff' }}></i>
                                    </div>

                                    <span style={{
                                        fontSize: '11px',
                                        fontWeight: 'bold',
                                        color: '#001871',
                                        marginTop: '2px',
                                        lineHeight: 1.1,
                                        textAlign: 'center',
                                        fontFamily: 'Futura, "Trebuchet MS", Arial, sans-serif'
                                    }}>
                                        {cob.limite}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default CoberturasMoto;
